import _ from 'lodash';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppConfig {
  anonId: string;
  paywallId: string;
  alreadyRegistered: boolean;
  templateId: string;
}

const initialState: AppConfig = {
  anonId: 'initial',
  paywallId: '',
  templateId: '',
  alreadyRegistered: false,
};

const analytics = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setAnalyticsData(
      state,
      action: PayloadAction<{
        anonId?: string;
        paywallId?: string;
        templateId?: string;
        alreadyRegistered?: boolean;
      }>,
    ) {
      if (action.payload.anonId) {
        state.anonId = action.payload.anonId;
      }
      if (action.payload.paywallId) {
        state.paywallId = action.payload.paywallId;
      }

      if (action.payload.templateId) {
        state.templateId = action.payload.templateId;
      }
      if (_.includes(Object.keys(action.payload), 'alreadyRegistered')) {
        state.alreadyRegistered = action.payload.alreadyRegistered || false;
      }
    },
  },
});

export const { setAnalyticsData } = analytics.actions;

export default analytics.reducer;
